module.exports = __webpack_public_path__ + "static/media/sad_turtle.de0ca0ac.svg";